import { HCP_SEGMENTATION_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';

const PREFERRED_CHANNEL_RATING_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.preferred_channel`],
  limit: undefined,
});

const preferredChannelRatingFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.preferredChannelRatingLabel',
  sourceCube: HCP_SEGMENTATION_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: PREFERRED_CHANNEL_RATING_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${HCP_SEGMENTATION_CUBE_NAME}.preferred_channel`]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.preferredChannelRatingPlaceholder',
  searchable: true,
  applyFilter: preferredChannelRatingFilterValue => {
    let preferredChannelRatingFilterValues: string[] = [];

    if (Array.isArray(preferredChannelRatingFilterValue)) {
      preferredChannelRatingFilterValues = preferredChannelRatingFilterValue.filter(
        (entry): entry is string => typeof entry === 'string',
      );
    } else if (typeof preferredChannelRatingFilterValue === 'string') {
      preferredChannelRatingFilterValues = [preferredChannelRatingFilterValue];
    }

    return {
      member: `${HCP_SEGMENTATION_CUBE_NAME}.preferred_channel`,
      operator: 'equals',
      values: preferredChannelRatingFilterValues,
    };
  },
};

export default preferredChannelRatingFilter;
